define('glu/grid/footer/tableFooterLayout',['require','../../layout','../../$','../../util','../../$window','../../$document','hbs!./tableFooterLayout.hbs'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        $ = require('../../$'),
        util = require('../../util'),
        $window = require('../../$window'),
        $document = require('../../$document'),
        tpl = require('hbs!./tableFooterLayout.hbs');

    return Layout.extend({
        template: tpl,

        appEvents: function() {
            var appEvents = {};

            if (this.hasStickyFooter) {
                appEvents.resize = 'changeFooterPosition';
            }

            return appEvents;
        },

        initialize: function() {
            this.grid = this.options.grid;
            this.hasStickyFooter = this.options.hasStickyFooter;

            if (this.hasStickyFooter) {
                this.changeFooterPosition = util.debounce(this.updateFooterPosition.bind(this), 20);
            }

            this.listenTo(this.grid, {
                'grid:columnWidthUpdated': this.handleGridContentRendered
            });
        },

        setBulkActions: function(view) {
            this.bulkActionsView = view;
        },

        setPager: function(view) {
            this.pagerView = view;
        },

        onRender: function() {
            this.showBulkActions();
            this.showPager();
            this.useStickyFooter();
        },

        showBulkActions: function() {
            if (this.bulkActionsView) {
                this.bulkActionsRegion.show(this.bulkActionsView);
            }
        },

        showPager: function() {
            if (this.pagerView) {
                this.pagerRegion.show(this.pagerView);
            }
        },

        handleGridContentRendered: function() {
            util.defer(function() {
                if (this.isClosed) {
                    return;
                }
                this.updateFooterPosition();
            }.bind(this));
        },

        useStickyFooter: function() {
            if (!this.hasStickyFooter) {
                return;
            }

            this.addStickyFooterEvents();

            util.defer(function() {
                if (this.isClosed) {
                    return;
                }
                this.initialGridBottomPadding = this.grid.$el.css('padding-bottom');
                this.initStickyScrollComponent();
                this.updateFooterPosition();
            }.bind(this));
        },

        updateFooterPosition: function() {
            if (this.isClosed || !this.hasStickyFooter) {
                return;
            }

            var $tableBody = this.grid.$('tbody[aria-live="polite"]'),
                offset = $tableBody.offset(),
                $footer = this.$el,
                docViewTop = $window.scrollTop(),
                docViewBottom = docViewTop + $window.height(),
                tableTop = offset ? offset.top : 0,
                tableBottom = tableTop + $tableBody.height(),
                rowHeight = $tableBody.find('tr').height(),
                footerHeight = $footer.height();

            if (!$tableBody.isScrolledIntoView() || (((tableBottom - docViewBottom) <= -50) || ((docViewBottom - tableTop) < (rowHeight + footerHeight)))) {
                $footer.removeClass('sticky-footer');
                this.grid.$el.css('padding-bottom', this.initialGridBottomPadding);
                this.hideStickyScroll();
                return;
            }

            this.updateStickyScroll();
            $footer.addClass('sticky-footer');
            this.grid.$el.css('padding-bottom', footerHeight);
        },

        addStickyFooterEvents: function() {
            $window.on('scroll.grid.' + this.grid.cid, this.changeFooterPosition);

            if (!this.pagerView) {
                return;
            }

            // need to listen all collection events to update footer position
            this.listenTo(this.pagerView.inputCollection, 'add reset remove sync', this.changeFooterPosition, this);
        },

        initStickyScrollComponent: function() {
            var $tableLayout = this.grid.$('.table-layout');

            this.stickyScrollOptions = {
                $container: $tableLayout,
                left: 0,
                top: 0,
                bottom: 0,
                height: 0,
                width: 0,
                visible: true
            };
            this.$stickyScrollBar = this.initStickyScrollBar();
            this.updateStickyScroll();
            this.syncStickyScrollBarWithTable($tableLayout);
            this.addStickyScrollEvents();
        },

        initStickyScrollBar: function() {
            var $stickyScroll = $('<div class="grid-sticky-scroll"></div>'); // eslint-disable-line backbone/no-native-jquery
            $('<div/>').appendTo($stickyScroll).css({ // eslint-disable-line backbone/no-native-jquery
                width: this.stickyScrollOptions.$container.prop('scrollWidth') + 'px'
            });

            this.stickyScrollOptions.bottomPosition = this.$el.outerHeight() - 1; // use -1px from footer height to prevent showing content behind scroll bar.

            $stickyScroll.css({
                bottom: this.stickyScrollOptions.bottomPosition
            });
            return $stickyScroll.appendTo('body');
        },

        addStickyScrollEvents: function() {
            util.extend(this.stickyScrollOptions, {
                eventHandlers: [{
                    $el: this.$stickyScrollBar,
                    handlers: {
                        'scroll.sticky': function(e) {
                            if (this.stickyScrollOptions && this.stickyScrollOptions.visible) {
                                this.syncTableWithStickyScroll($document.find(e.target));
                            }
                        }.bind(this)
                    }
                }, {
                    $el: this.stickyScrollOptions.$container,
                    handlers: {
                        'scroll.sticky': function(e) {
                            if (this.stickyScrollOptions && !this.stickyScrollOptions.visible) {
                                this.syncStickyScrollBarWithTable($document.find(e.target));
                            }
                        }.bind(this),
                        'focusin.sticky': function() {
                            util.defer(function() {
                                this.syncStickyScrollBarWithTable(this.stickyScrollOptions.$container);
                            }.bind(this));
                        }.bind(this)
                    }
                }]
            });

            util.each(this.stickyScrollOptions.eventHandlers, function(item) {
                util.each(item.handlers, function(callback, event) {
                    item.$el.on(event + '.' + this.grid.cid, callback);
                }, this);
            }, this);
        },

        checkScrollVisibility: function() {
            if (this.isClosed) {
                return;
            }
            var stickyScrollOptions = this.stickyScrollOptions,
                mustHide = (this.$stickyScrollBar.prop('scrollWidth') <= this.$stickyScrollBar.prop('offsetWidth')),
                footerHeight = this.$el.outerHeight() - 1; // use -1px from footer height to prevent showing content behind scroll bar.

            if (stickyScrollOptions.visible === mustHide) {
                stickyScrollOptions.visible = !stickyScrollOptions.visible;
                // we cannot simply hide a sticky scroll bar since its scrollLeft property will not update in that case
                this.$stickyScrollBar.toggleClass('grid-sticky-scroll-hidden');
            }

            // can be when screen is small and footer has simple pagination
            if (this.stickyScrollOptions.bottomPosition !== footerHeight) {
                this.stickyScrollOptions.bottomPosition = footerHeight;
                this.$stickyScrollBar.css({
                    bottom: this.stickyScrollOptions.bottomPosition
                });
            }
        },

        syncStickyScrollBarWithTable: function($sender) {
            if (this.isClosed) {
                return;
            }
            this.$stickyScrollBar.prop('scrollLeft', $sender.prop('scrollLeft'));
        },

        syncTableWithStickyScroll: function($sender) {
            if (this.isClosed) {
                return;
            }
            this.stickyScrollOptions.$container.prop('scrollLeft', $sender.prop('scrollLeft'));
        },

        updateStickyScroll: function() {
            if (this.isClosed || !this.stickyScrollOptions) {
                return;
            }
            var stickyScrollOptions = this.stickyScrollOptions,
                $tableLayout = stickyScrollOptions.$container,
                offset = $tableLayout.offset();

            // No offset means no element.
            if (!offset) {
                return;
            }

            stickyScrollOptions.height = $tableLayout.outerHeight();
            stickyScrollOptions.width = $tableLayout.outerWidth();
            stickyScrollOptions.left = offset.left;
            stickyScrollOptions.top = offset.top;
            stickyScrollOptions.bottom = stickyScrollOptions.top + stickyScrollOptions.height;
            this.$stickyScrollBar.width(stickyScrollOptions.width).css('left', stickyScrollOptions.left + 'px');
            this.$stickyScrollBar.find('div').width($tableLayout.prop('scrollWidth'));
            this.checkScrollVisibility();
        },

        // Remove a scrollbar and all related event handlers
        destroyStickyScrollElement: function() {
            if (!this.stickyScrollOptions) {
                return;
            }

            util.each(this.stickyScrollOptions.eventHandlers, function(item) {
                util.each(item.handlers, function(callback, event) {
                    item.$el.off(event + '.' + this.grid.cid);
                }, this);
            }, this);
            this.stickyScrollOptions = {};
            this.$stickyScrollBar.remove();
        },

        hideStickyScroll: function() {
            if (this.isClosed || !this.stickyScrollOptions) {
                return;
            }
            this.stickyScrollOptions.visible = false;
            this.$stickyScrollBar.addClass('grid-sticky-scroll-hidden');
        },

        onClose: function() {
            if (this.hasStickyFooter) {
                $window.off('scroll.grid.' + this.grid.cid);
                this.destroyStickyScrollElement();
            }
        }
    });
});

